import { Component, OnInit } from '@angular/core';
import { Student } from '../student-list/student';
import { TestService } from '../_services/test.service';
import { StudentService } from '../_services/student.service';
import { Subscription } from 'rxjs';
import { Test } from './test';
import { ResponsiveService } from '../_services/responsive.service';
import { ToastService } from '../_services/toast-service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from '../_helpers/roles';

import { LoaderService } from '../loader/loader.service';
@Component({
	selector: 'app-test-history',
	templateUrl: './test-history.component.html',
	styleUrls: ['./test-history.component.css'],
})
export class TestHistoryComponent implements OnInit {
	testHistory: Test[];
	page = 1;
	is_mobile = false;
	role: null;
	activeStudent: Student;
	subscriptions: Subscription[] = [];
	activePhase: any;

	constructor(
		private studentService: StudentService,
		private testService: TestService,
		public rsp: ResponsiveService,
		public toastService: ToastService,
		private jwtHelper: JwtHelperService,
		public LoaderService: LoaderService,
	) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.studentService.selectedStudent$.subscribe((studentData: Student) => {
				if (studentData) {
					this.activeStudent = studentData;

					this.activePhase = localStorage.getItem('activePhase')
						? JSON.parse(localStorage.getItem('activePhase'))
						: this.activeStudent.phases.slice(-1)[0];

					this.getTestHistory();
				} else {
					this.testHistory = [];
				}
			}),
		);
		this.subscriptions.push(
			this.testService.testHistory.subscribe((testData: Test[]) => {
				//whenever test history changes, initialize it to display.
				this.testHistory = testData;
				if (this.activeStudent.triggerFlag == 'delete') {
				} else {
					this.page = this.testHistory.length;
				}
			}),
		);
	}

	getTestHistory() {
		this.subscriptions.push(
			this.testService
				.getPhonicsTestHistory(
					this.activeStudent.id,
					this.activeStudent.assessmentBookId,
					this.activeStudent.assessmentTemplateId,
				)
				.subscribe(
					(data) => {
						this.testService.setTestHistory(data.testHistory);
						console.log(data.testHistory);
					},
					(error) => {
						console.log(error);
					},
				),
		);
	}

	changePage(i: number) {
		this.page = i + 1;
	}
	canDelete() {
		const token = localStorage.getItem('currentUser');
		const decoded = this.jwtHelper.decodeToken(token);
		this.role = decoded.role;
		const deleteScores = decoded.canDeleteScores;
		if (
			this.role == Role.Teacher ||
			this.role == Role.Admin ||
			this.role == Role.AdminLite ||
			deleteScores
		) {
			return true;
		} else {
			return false;
		}
	}

	deleteThisScore(scoreId) {
		let submitObject: {
			scoreId: any;
			assessmentBookId: any;
			assessmentTemplateId: any;
			participantId: any;
		} = {
			scoreId: '',
			assessmentBookId: '',
			assessmentTemplateId: '',
			participantId: '',
		};
		submitObject.scoreId = scoreId;
		submitObject.assessmentBookId = this.activeStudent.assessmentBookId;
		submitObject.assessmentTemplateId = this.activeStudent.assessmentTemplateId;
		submitObject.participantId = this.activeStudent.id;
		this.subscriptions.push(
			this.testService.deletePhonicsScore(submitObject).subscribe(
				(data) => {
					this.toastService.showSuccess('Successfully Deleted');
					this.studentService.setStudent(this.activeStudent);
					localStorage.setItem('historyPage', JSON.stringify(this.page));
				},
				(error) => {
					this.toastService.showError(error);
				},
			),
		);
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
